declare const __APP_VERSION__: string;

/** Versión de producto inyectada en build (archivo VERSION en la raíz del repo). */
export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';

export function formatAppVersionLabel(): string {
  return `v${APP_VERSION}`;
}
